module.exports = __webpack_public_path__ + "static/media/selectLeaderDefaultView.4bf2bfe7.svg";